import FooterSection from '@/pages/home/components/FooterSection';

const pilares = [
  {
    num: '01',
    title: 'Mapa de Gargalos e Alavancas',
    icon: 'ri-map-2-line',
    color: 'bg-violet-600',
    corBg: 'bg-violet-50',
    border: 'border-violet-200',
    text: 'text-violet-600',
    objetivo: 'Implementar as ações definidas no mapa de gargalos.',
    conteudo: [
      'Priorização de gargalos por impacto',
      'Plano de ação com responsáveis e prazos',
      'Monitoramento de avanços semanais',
      'Alavancas de crescimento identificadas',
    ],
    entregavel: 'Gargalos resolvidos ou em execução — com plano documentado',
  },
  {
    num: '02',
    title: 'Gestao e Estrutura Operacional',
    icon: 'ri-building-2-line',
    color: 'bg-sky-600',
    corBg: 'bg-sky-50',
    border: 'border-sky-200',
    text: 'text-sky-600',
    objetivo: 'Colocar processos e rotinas para funcionar na prática.',
    conteudo: [
      'Definição de estrutura organizacional',
      'Processos documentados e em execução',
      'Rotinas operacionais implementadas',
      'Indicadores de gestão acompanhados',
    ],
    entregavel: 'Estrutura organizacional clara — processos rodando sem o dono',
  },
  {
    num: '03',
    title: 'Organização Financeira',
    icon: 'ri-money-dollar-circle-line',
    color: 'bg-emerald-600',
    corBg: 'bg-emerald-50',
    border: 'border-emerald-200',
    text: 'text-emerald-600',
    objetivo: 'Colocar as finanças do negócio sob controle real.',
    conteudo: [
      'Fluxo de caixa estruturado e monitorado',
      'DRE simplificado em prática',
      'Controle de custos e margem de contribuição',
      'Dashboard financeiro em uso real',
    ],
    entregavel: 'Planejamento Financeiro — sabendo quanto fatura e quanto lucra',
  },
  {
    num: '04',
    title: 'Estrutura Comercial',
    icon: 'ri-bar-chart-grouped-line',
    color: 'bg-orange-600',
    corBg: 'bg-orange-50',
    border: 'border-orange-200',
    text: 'text-orange-600',
    objetivo: 'Construir uma máquina de vendas que funciona sozinha.',
    conteudo: [
      'Funil comercial documentado e em operação',
      'Scripts de vendas implementados',
      'Rotina de prospecção e follow-up ativa',
      'Métricas de conversão acompanhadas',
    ],
    entregavel: 'Máquina comercial funcionando — previsibilidade de vendas',
  },
  {
    num: '05',
    title: 'Inovação e Eficiência Empresarial',
    icon: 'ri-lightbulb-flash-line',
    color: 'bg-teal-600',
    corBg: 'bg-teal-50',
    border: 'border-teal-200',
    text: 'text-teal-600',
    objetivo: 'Aplicar inovação e diferenciação no negócio.',
    conteudo: [
      'Modelo de negócio revisado e implementado',
      'Diferenciação competitiva colocada em prática',
      'Novos produtos ou serviços lançados',
      'Processos otimizados com ganhos mensuráveis',
    ],
    entregavel: 'Plano de inovação executado — diferenciação no mercado',
  },
  {
    num: '06',
    title: 'Inteligência Artificial Aplicada ao Negócio',
    icon: 'ri-robot-line',
    color: 'bg-rose-600',
    corBg: 'bg-rose-50',
    border: 'border-rose-200',
    text: 'text-rose-600',
    objetivo: 'Usar IA para automatizar e acelerar processos.',
    conteudo: [
      'IA implementada no atendimento ao cliente',
      'Automação de tarefas operacionais',
      'Assistentes empresariais com IA ativos',
      'Análise de dados assistida por IA',
    ],
    entregavel: 'Ferramentas de IA implementadas e em uso — processos 10x mais rápidos',
  },
];

const fases = [
  {
    num: '01',
    title: 'Organizar',
    subtitle: 'Dias 1 a 30',
    desc: 'Estruturar a base: processos, funções e ferramentas.',
    icon: 'ri-tools-line',
    color: 'bg-violet-600',
    items: [
      'Definir estrutura e responsabilidades',
      'Mapear processos críticos',
      'Implementar ferramentas básicas',
      'Criar rotinas de acompanhamento',
    ],
  },
  {
    num: '02',
    title: 'Implementar',
    subtitle: 'Dias 31 a 60',
    desc: 'Executar cada pilar do plano de ação.',
    icon: 'ri-rocket-line',
    color: 'bg-amber-500',
    items: [
      'Ação semanal em cada área',
      'Reuniões quinzenais de acompanhamento',
      'Correções de rota em tempo real',
      'Documentação de cada implementação',
    ],
  },
  {
    num: '03',
    title: 'Consolidar',
    subtitle: 'Dias 61 a 90',
    desc: 'Institucionalizar — fazer funcionar sem o dono.',
    icon: 'ri-government-line',
    color: 'bg-emerald-600',
    items: [
      'Processos em modo autônomo',
      'Indicadores consolidados',
      ' handover ao time interno',
      'Plano de continuidade documentado',
    ],
  },
];

export default function ImplementacaoPage() {
  return (
    <div className="min-h-screen bg-gray-950 text-white">

      {/* ── HERO ── */}
      <section className="relative overflow-hidden">
        {/* Background gradient */}
        <div className="absolute inset-0 bg-gradient-to-br from-gray-950 via-gray-900 to-violet-950" />
        <div className="absolute inset-0 opacity-30"
          style={{
            backgroundImage: 'radial-gradient(circle at 30% 50%, rgba(139, 92, 246, 0.15) 0%, transparent 50%), radial-gradient(circle at 80% 20%, rgba(245, 158, 11, 0.1) 0%, transparent 40%)',
          }}
        />

        <div className="relative max-w-6xl mx-auto px-6 py-24 md:py-32">
          {/* Badge */}
          <div className="flex justify-center mb-8">
            <div className="inline-flex items-center gap-2 bg-amber-500/10 border border-amber-500/30 rounded-full px-5 py-2">
              <i className="ri-rocket-line text-amber-400" />
              <span className="text-amber-400 text-xs font-bold tracking-widest uppercase">Programa de Implementação</span>
            </div>
          </div>

          <h1 className="text-4xl md:text-6xl lg:text-7xl font-black text-center mb-6 leading-tight">
            Implementação Real <span className="text-amber-400">90D</span>
          </h1>

          <p className="text-white/60 text-lg md:text-xl text-center max-w-2xl mx-auto mb-4">
            Seu negócio foi mapeado. Agora vamos implementar —<br className="hidden md:block" />
            <strong className="text-white">de verdade, em cada área, durante 90 dias.</strong>
          </p>

          <p className="text-white/40 text-center text-sm md:text-base max-w-xl mx-auto mb-12">
            Acompanhamento presencial +顾问 online em cada pilar do seu negócio.
            Nada de teoria — só execução.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="https://wa.me/5592984398338?text=Olá! Quero saber mais sobre a Implementação Real 90D"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-amber-500 hover:bg-amber-400 text-gray-950 font-black text-base px-8 py-4 rounded-xl transition-all duration-300 hover:scale-105"
            >
              <i className="ri-whatsapp-line text-xl" />
              Quero Implementar
            </a>
            <a
              href="#pilares"
              className="inline-flex items-center justify-center gap-2 bg-white/5 border border-white/20 hover:border-white/40 text-white font-bold text-base px-8 py-4 rounded-xl transition-all"
            >
              Como Funciona
              <i className="ri-arrow-down-line" />
            </a>
          </div>
        </div>
      </section>

      {/* ── DIFERENCIAL ── */}
      <section className="py-20 bg-gray-900">
        <div className="max-w-5xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-red-950/30 border border-red-500/20 rounded-3xl p-8">
              <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-red-500/20 mb-5">
                <i className="ri-file-list-3-line text-red-400 text-2xl" />
              </div>
              <h3 className="text-xl font-black text-white mb-3">TR60D — Plano Completo</h3>
              <p className="text-white/50 text-sm leading-relaxed">
                Você já sabe <strong className="text-white">o que</strong> precisa ser feito.
                Diagnóstico feito, mapa de gargalos definido, plano de ação montado.
              </p>
            </div>
            <div className="bg-emerald-950/30 border border-emerald-500/20 rounded-3xl p-8">
              <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-emerald-500/20 mb-5">
                <i className="ri-hammer-line text-emerald-400 text-2xl" />
              </div>
              <h3 className="text-xl font-black text-white mb-3">IR90D — Implementação Real</h3>
              <p className="text-white/50 text-sm leading-relaxed">
                Agora vamos <strong className="text-white">fazer acontecer</strong>.
                90 dias de implementação em cada área — com acompanhamento presencial e顾问 online.
              </p>
            </div>
          </div>

          <div className="mt-10 text-center">
            <p className="text-2xl md:text-3xl font-black text-white mb-2">
              Do plano → para a prática.
            </p>
            <p className="text-white/40 text-base">
              O TR60D mostra o caminho. O IR90D percorre o caminho <strong className="text-amber-400">com você</strong>.
            </p>
          </div>
        </div>
      </section>

      {/* ── PILARES ── */}
      <section id="pilares" className="py-24 bg-gray-950">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-16">
            <p className="text-xs font-semibold tracking-[0.25em] uppercase text-stone-400 mb-4">
              O que será implementado
            </p>
            <h2 className="text-4xl md:text-5xl font-black text-white leading-tight mb-4">
              6 Pilares de <span className="text-amber-400">Implementação</span>
            </h2>
            <p className="text-white/50 text-lg max-w-xl mx-auto">
              Cada pilar é implementado na prática durante os 90 dias —
              com ações concretas, entregas e resultados visíveis.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {pilares.map((p) => (
              <div key={p.num} className={`rounded-2xl border ${p.border} ${p.corBg} p-6`}>
                <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${p.color} mb-4`}>
                  <i className={`${p.icon} text-white text-xl`} />
                </div>
                <div className={`text-5xl font-black ${p.text} opacity-20 mb-2 leading-none`}>{p.num}</div>
                <h3 className="text-lg font-black text-gray-900 mb-2">{p.title}</h3>
                <p className="text-gray-500 text-xs mb-4 leading-relaxed">{p.objetivo}</p>

                <div className="border-t border-gray-200 pt-4 mb-4">
                  <p className="text-xs font-bold uppercase tracking-widest text-gray-400 mb-3">O que será feito:</p>
                  <ul className="space-y-2">
                    {p.conteudo.map((item) => (
                      <li key={item} className="flex items-start gap-2 text-gray-700 text-xs">
                        <i className={`${p.color} text-white text-[10px] w-4 h-4 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5`}>
                          <i className="ri-check-line text-[10px]" />
                        </i>
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>

                <div className={`${p.color} text-white text-xs font-bold px-4 py-2 rounded-lg text-center`}>
                  ✓ {p.entregavel}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── ROADMAP ── */}
      <section className="py-24 bg-gray-900">
        <div className="max-w-5xl mx-auto px-6">
          <div className="text-center mb-16">
            <p className="text-xs font-semibold tracking-[0.25em] uppercase text-stone-400 mb-4">
              Como funciona
            </p>
            <h2 className="text-4xl md:text-5xl font-black text-white leading-tight mb-4">
              Roadmap em <span className="text-amber-400">90 Dias</span>
            </h2>
            <p className="text-white/50 text-base max-w-lg mx-auto">
              Três fases de 30 dias — do planejamento à independência do dono.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {fases.map((f, i) => (
              <div key={f.num} className="relative">
                {/* Connector line */}
                {i < fases.length - 1 && (
                  <div className="hidden md:block absolute top-10 left-[calc(50%+2rem)] right-[calc(-50%+2rem)] h-0.5 bg-gradient-to-r from-white/20 to-transparent z-0" />
                )}
                <div className="relative z-10 bg-gray-800 border border-white/10 rounded-3xl p-8 text-center">
                  <div className={`w-16 h-16 mx-auto flex items-center justify-center rounded-2xl ${f.color} mb-5`}>
                    <i className={`${f.icon} text-white text-2xl`} />
                  </div>
                  <div className={`text-xs font-bold uppercase tracking-widest ${f.color.replace('bg-', 'text-')} mb-1`}>{f.subtitle}</div>
                  <h3 className="text-2xl font-black text-white mb-3">{f.title}</h3>
                  <p className="text-white/50 text-sm mb-6 leading-relaxed">{f.desc}</p>
                  <ul className="space-y-3 text-left">
                    {f.items.map((item) => (
                      <li key={item} className="flex items-start gap-3 text-white/60 text-sm">
                        <i className="ri-check-line text-emerald-400 text-sm flex-shrink-0 mt-0.5" />
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── FORMATO ── */}
      <section className="py-24 bg-gray-950">
        <div className="max-w-5xl mx-auto px-6">
          <div className="text-center mb-16">
            <p className="text-xs font-semibold tracking-[0.25em] uppercase text-stone-400 mb-4">
              Formato do programa
            </p>
            <h2 className="text-4xl md:text-5xl font-black text-white leading-tight">
              Presencial + <span className="text-amber-400">Online</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white/5 border border-white/10 rounded-3xl p-8">
              <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-amber-500/20 mb-6">
                <i className="ri-building-line text-amber-400 text-2xl" />
              </div>
              <h3 className="text-xl font-black text-white mb-3">100% Presencial</h3>
              <p className="text-white/50 text-sm leading-relaxed mb-4">
                A implementação happens where your business lives — no escritório, na operação, no chão de fábrica.
              </p>
              <ul className="space-y-3">
                {[
                  'Imersões presenciais no seu negócio',
                  'Reuniões de trabalho com a equipe',
                  'Implementação in loco',
                  'Treinamento da sua equipe',
                ].map((item) => (
                  <li key={item} className="flex items-start gap-3 text-white/60 text-sm">
                    <i className="ri-check-line text-amber-400 text-sm flex-shrink-0 mt-0.5" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            <div className="bg-white/5 border border-white/10 rounded-3xl p-8">
              <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-sky-500/20 mb-6">
                <i className="ri-computer-line text-sky-400 text-2xl" />
              </div>
              <h3 className="text-xl font-black text-white mb-3">Acompanhamento Online</h3>
              <p className="text-white/50 text-sm leading-relaxed mb-4">
                Entre as visitas presenciais, o acompanhamento é permanente — para garantir ritmo e consistência.
              </p>
              <ul className="space-y-3">
                {[
                  'Reuniões quinzenais por video',
                  'Suporte por WhatsApp durante toda a semana',
                  'Planilhas e templates para acompanhamento',
                  'Relatórios mensais de evolução',
                ].map((item) => (
                  <li key={item} className="flex items-start gap-3 text-white/60 text-sm">
                    <i className="ri-check-line text-sky-400 text-sm flex-shrink-0 mt-0.5" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <section className="py-24 bg-gradient-to-br from-amber-600 to-amber-700">
        <div className="max-w-3xl mx-auto px-6 text-center">
          <div className="w-20 h-20 flex items-center justify-center rounded-full bg-white/20 mx-auto mb-8">
            <i className="ri-rocket-line text-white text-4xl" />
          </div>
          <h2 className="text-3xl md:text-5xl font-black text-white mb-4">
            Chega de plano na gaveta.
          </h2>
          <p className="text-white/80 text-lg mb-4 max-w-xl mx-auto">
            Você já tem o diagnóstico. Agora é hora de implementar — com quem vai fazer acontecer ao seu lado.
          </p>
          <p className="text-white/60 text-sm mb-10">
            Duração: 90 dias &nbsp·&nbsp Presencial + Online &nbsp·&nbsp Acompanhamento completo
          </p>

          <a
            href="https://wa.me/5592984398338?text=Olá! Quero saber mais sobre a Implementação Real 90D"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-3 bg-gray-950 hover:bg-gray-800 text-white font-black text-lg px-10 py-5 rounded-2xl transition-all duration-300 hover:scale-105"
          >
            <i className="ri-whatsapp-line text-2xl" />
            Falar com Consultor
          </a>

          <p className="text-white/50 text-xs mt-6">
            Investimento sob consulta — agende uma conversa sem compromisso.
          </p>
        </div>
      </section>

      {/* ── FOOTER ── */}
      <FooterSection />

    </div>
  );
}
